import React from 'react';

interface ShareIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ShareIcon: React.FC<ShareIconProps> = ({ size = 24, color = '#134563', className = '' }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 64 64" 
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g transform="translate(280.000000, 380.000000)">
          <path 
            fill={color} 
            d="M-264.2-339.9c-4.4,0-7.9-3.5-7.9-7.9c0-4.4,3.5-7.9,7.9-7.9c4.4,0,7.9,3.5,7.9,7.9 C-256.3-343.5-259.8-339.9-264.2-339.9L-264.2-339.9z M-264.2-352.8c-2.7,0-4.9,2.2-4.9,4.9c0,2.7,2.2,4.9,4.9,4.9 c2.7,0,4.9-2.2,4.9-4.9C-259.3-350.5-261.5-352.8-264.2-352.8L-264.2-352.8z"
          />
          <path 
            fill={color} 
            d="M-232.1-356c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9S-227.8-356-232.1-356 L-232.1-356z M-232.1-368.8c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9S-229.4-368.8-232.1-368.8L-232.1-368.8z"
          />
          <path 
            fill={color} 
            d="M-232.1-323.9c-4.4,0-7.9-3.5-7.9-7.9s3.5-7.9,7.9-7.9s7.9,3.5,7.9,7.9 S-227.8-323.9-232.1-323.9L-232.1-323.9z M-232.1-336.7c-2.7,0-4.9,2.2-4.9,4.9s2.2,4.9,4.9,4.9s4.9-2.2,4.9-4.9 S-229.4-336.7-232.1-336.7L-232.1-336.7z"
          />
          <path 
            fill={color} 
            d="M-238.6,-333.2 L-259.2,-343.5 L-257.8,-346.4 L-237.1,-336.1 L-238.6,-333.2"
          />
          <path 
            fill={color} 
            d="M-257.8,-349.3 L-259.2,-352.1 L-238.6,-362.4 L-237.1,-359.6 L-257.8,-349.3"
          />
        </g>
      </g>
    </svg>
  );
};

export default ShareIcon;
